export const ETH_VALUE = 1000000000000000000;